import { useGetFitterQuery } from 'feature/user/redux/fitter.api'
import { LoaderInCentalPosition } from 'widget'
import styles from './LkmRegionList.module.scss'

export function LkmRegionList() {
  const { data, isLoading } = useGetFitterQuery()

  if (isLoading && !data) return <LoaderInCentalPosition />

  return (
    <div className={styles.productTypesList}>
      {data?.regions.map(item => (
        <div key={item.kladrId} className={styles.productTypesList__item}>
          {item.name}
        </div>
      ))}
    </div>
  )
}
